import React, { Children } from "react"
import { Navigate } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import AdminLogin from "../pages/AdminAuthentication/Login"
import Register from "../pages/Authentication/Register"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Permissions from "pages/Permissions"
import Investors from "pages/Investors"
import EditRoles from "pages/Roles/edit"
import EditUsers from "pages/Users/edit"
import Verify from "pages/Authentication/Verify"
import ViewICD from "pages/ICD/view"
import CreateICD from "pages/ICD/create"
import ICDList from "pages/ICD"
import InviteInvestor from "pages/Investors/invite"
import WealthPartners from "pages/WealthPartner"
import InviteWealthPartner from "pages/WealthPartner/invite"
import ViewWealthPartner from "pages/WealthPartner/view"
import ViewInvestor from "pages/Investors/view"
import RequestsREITs from "pages/REITs/requests"
import ViewREITs from "pages/REITs/view"
import CreateREITs from "pages/REITs/create"
import REITs from "pages/REITs"
import RequestsViewREITs from "pages/REITs/requestsView"
import GenerateFinancialReports from "pages/Reports/generateFinancialReports"
import TrackTotalFundsRaised from "pages/Reports/trackTotalFundsRaised"
import InvestorActivityReports from "pages/Reports/investorActivityReports"
import ExportTransactionHistory from "pages/Reports/exportTransactionHistory"
import RegulatoryComplianceReports from "pages/Reports/regulatoryComplianceReports"
import SystemConfiguration from "pages/PlatformManager/systemConfiguration"
import IntegrationManagement from "pages/PlatformManager/integrationManagement"
import CreateICDInvestments from "pages/InvestorPages/ICDInvestments/create"
import MyICDRequests from "pages/InvestorPages/ICDInvestments/myICDRequests"
import FundRequests from "pages/InvestorPages/ICDInvestments/fundRequests"
import ICDRequestDetails from "pages/InvestorPages/ICDInvestments/requestDetails"
import Profile from "pages/Profile"
import TwoFactor from "pages/Authentication/TwoFactor"
import TwoFactorAdmin from "pages/AdminAuthentication/TwoFactorAdmin"
import ICDOffers from "pages/ICD/offers"
import NotFound from "pages/NotFound/NotFound"
import InvestorDashboard from "pages/Dashboard/investorDashboard"
import QuarterlyTDSCertificates from "pages/Reports/quarterlyTDSCertificates"
import AdminVerify from "pages/AdminAuthentication/AdminVerify"
import MyICDInterests from "pages/InvestorPages/ICDInvestments/myInterests"
import Forbidden from "pages/Forbidden/forbidden"
import MyICDRequestsView from "pages/InvestorPages/ICDInvestments/myICDRequestsView"
import KYC from "pages/KYC"
import InvestorRouteWrapper from "pages/InvestorPages/ICDInvestments/investorRouteWrapper"
import ResolveKyc from "pages/resolveKyc"
import MyRequests from "pages/ICD/myRequests"
import InvestorManagement from "pages/WealthPartnerPages/InvestorManagement"
import InvestorManagementInvite from "pages/WealthPartnerPages/InvestorManagement/invite"
import InvestorManagementInviteView from "pages/WealthPartnerPages/InvestorManagement/view"
import WealthRouteWrapper from "pages/WealthPartnerPages/WealthRouteWrapper"
import Blogs from "pages/adminCms/Blogs"
import BlogList from "pages/adminCms/blogList"
import BlogEdit from "pages/adminCms/blogEdit"
import CreateFaq from "pages/faqs/createFaqs"
import FaqList from "pages/faqs/faqsList"
import FaqEdit from "pages/faqs/faqEdit"
import UploadVideo from "pages/videos/uploadVideo"
import VideoList from "pages/videos/videoList"
import VideoEdit from "pages/videos/videoEdit"
import CreateDocument from "pages/documents/createDocument"
import DocmmentList from "pages/documents/docmmentList"
import DocumentEdit from "pages/documents/documentEdit"
import FounderMessage from "pages/Founder-message"
import AboutUs from "pages/About-us"
import BlogView from "pages/InvestorPages/reports/blogView"
import Playlist from "pages/InvestorPages/reports/playlist"
import ProfileUpdate from "pages/Profile/update"
import ProfileDelete from "pages/Profile/delete/profileDelete"
import AboutICD from "pages/About-Icd"
import AboutPrachay from "pages/InvestorPages/Resources"
import AboutIcdInvestor from "pages/InvestorPages/Resources/aboutIcd"
import FaqResources from "pages/InvestorPages/Resources/faq"
import Documents from "pages/InvestorPages/reports/documents"
import HelpRequests from "pages/help/helpRequests"
import TdsYearList from "pages/Reports/tdsYearList"
import TdsQuarterList from "pages/Reports/tdsQuarterList"
import CreateTds from "pages/Reports/createTds"
import InvestmentSchedule from "pages/InvestorPages/ICDInvestments/investmentSchedule"
import WealthFinancialReport from "pages/WealthPartner/reports/wealthFinancialReport"
import ICDSigningDocsRequests from "pages/ICD/icdSigningDocsRequests"
import InvestorsProfileUpdate from "pages/Investors/profile-updates"
import ViewInvestorsProfileRequest from "pages/Investors/profile-updates/view"
import ForgotPassword from "pages/Authentication/forgotPassword"
import AdminForgotPassword from "pages/AdminAuthentication/adminForgetPassword"
import ResetPassword from "pages/Authentication/resetPassword"
import AdminResetPassword from "pages/AdminAuthentication/adminResetPassword"
import Agreements from "pages/Investors/agreements"
import CompanyInfo from "pages/Profile/companyInfo"
import BankDetails from "pages/Profile/bankDetails"
import AuthorisedSignatoryDetails from "pages/Profile/authorisedSignatoryDetails"
import KycDocuments from "pages/Profile/kycDocuments"
import PersonalInformation from "pages/Profile/personalInformation"
import IcdMasterAgreement from "pages/Profile/executedDocs/icdMasterAgreement"
import PaymentPage from "pages/InvestorPages/ICDInvestments/paymentPage"
import SigningRequests from "pages/InvestorPages/ICDInvestments/signingRequests"
import EditInvestorUsers from "pages/InvestorPages/Users/edit"
import CreateInvestorUsers from "pages/InvestorPages/Users/create"
import InvestorUsers from "pages/InvestorPages/Users"
import InvestorPermissionWrapper from "pages/InvestorPages/ICDInvestments/investorPermissionWrapper"
import Notifications from "pages/InvestorPages/Notifications"
import AccountDeletions from "pages/Investors/AccountDeletions"
import UserMangement from "pages/UserMangement"
import UserMangementCreate from "pages/UserMangement/create"
import UserDashboard from "pages/Dashboard/userDashboard"
import UserPayments from "pages/ICD/payment"
import Signers from "pages/Signers"
import IcdMasterAgreementWp from "pages/WealthPartnerPages/InvestorManagement/executedDocs/icdMasterAgreementWp"
import FundRequestsWp from "pages/WealthPartnerPages/Icds/FundRequestsWp"
import CreateICDInvestmentsWp from "pages/WealthPartnerPages/Icds/CreateICDInvestmentsWp"
import ICDRequestsWp from "pages/WealthPartnerPages/Icds/ICDRequestsWp"
import ViewICDRequestsWp from "pages/WealthPartnerPages/Icds/ViewICDRequestsWp"
import PaymentPageWp from "pages/WealthPartnerPages/Icds/PaymentPageWp"
import ComingSoon from "components/Common/ComingSoon"
import SigningRequestsWp from "pages/WealthPartner/SigningRequestsWp"

const authProtectedRoutes = [
  { path: "/user-dashboard", component: <UserDashboard /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/investor-dashboard", component: <InvestorDashboard /> },
  { path: "/profile", component: <Profile /> },
  { path: "/profile/update", component: <ProfileUpdate /> },
  { path: "/profile/delete", component: <ProfileDelete /> },

  { path: "/user-management", component: <UserMangement /> },
  { path: "/user-management/create", component: <UserMangementCreate /> },
  { path: "/user-management/users/edit/:id", component: <EditUsers /> },
  { path: "/user-management/roles/edit/:id", component: <EditRoles /> },
  { path: "/permissions", component: <Permissions /> },

  { path: "/investors/invite", component: <InviteInvestor /> },
  { path: "/investors/invite/:id", component: <InviteInvestor /> },
  { path: "/investors", component: <Investors /> },
  { path: "/investors/view/:id", component: <ViewInvestor /> },
  { path: "/investors/agreements", component: <Agreements type="INVESTOR" /> },
  {
    path: "/investors/profile-updates",
    component: <InvestorsProfileUpdate type="INVESTOR" />,
  },
  {
    path: "/investors/profile-updates/view/:id",
    component: <ViewInvestorsProfileRequest type="INVESTOR" />,
  },
  {
    path: "/investors/account-deletions",
    component: <AccountDeletions type="INVESTOR" />,
  },

  { path: "/wealth-partners", component: <WealthPartners /> },
  { path: "/wealth-partners/invite", component: <InviteWealthPartner /> },
  { path: "/wealth-partners/invite/:id", component: <InviteWealthPartner /> },
  { path: "/wealth-partners/view/:id", component: <ViewWealthPartner /> },
  {
    path: "/wealth-partners/agreements",
    component: <Agreements type="WEALTH_PARTNER" />,
  },
  {
    path: "/wealth-partners/profile-updates",
    component: <InvestorsProfileUpdate type="WEALTH_PARTNER" />,
  },
  {
    path: "/wealth-partners/profile-updates/view/:id",
    component: <ViewInvestorsProfileRequest type="WEALTH_PARTNER" />,
  },
  {
    path: "/wealth-partners/account-deletions",
    component: <AccountDeletions type="WEALTH_PARTNER" />,
  },
  {
    path: "/wealth-partners/signing-docs",
    component: <SigningRequestsWp />,
  },

  { path: "/icd", component: <ICDList /> },
  { path: "/icd/my-requests", component: <MyRequests /> },
  { path: "/icd/create", component: <CreateICD /> },
  { path: "/icd/view/:id", component: <ViewICD /> },
  { path: "/icd/offers/:id", component: <ICDOffers /> },
  { path: "/icd/signing-docs", component: <ICDSigningDocsRequests /> },
  { path: "/icd/payments", component: <UserPayments /> },

  { path: "/reits", component: <REITs /> },
  { path: "/reits/create", component: <CreateREITs /> },
  { path: "/reits/view", component: <ViewREITs /> },
  {
    path: "/reits/requests-view",
    component: <RequestsViewREITs />,
  },
  { path: "/reits/requests", component: <RequestsREITs /> },
  {
    path: "/reports/generate-financial-reports",
    component: <GenerateFinancialReports />,
  },
  {
    path: "/reports/tds-years",
    component: <TdsYearList type={"tds"} />,
  },
  {
    path: "/reports/soa-years",
    component: <TdsYearList type={"soa"} />,
  },
  {
    path: "/reports/tds/:year",
    component: <TdsQuarterList type={"tds"} />,
  },
  {
    path: "/reports/soa/:year",
    component: <TdsQuarterList type={"soa"} />,
  },
  {
    path: "/reports/tds/:year/:period",
    component: <CreateTds type={"tds"} />,
  },
  {
    path: "/reports/soa/:year/:period",
    component: <CreateTds type={"soa"} />,
  },

  {
    path: "/reports/track-total-funds-taised",
    component: <TrackTotalFundsRaised />,
  },
  {
    path: "/reports/investor-activity-reports",
    component: <InvestorActivityReports />,
  },
  {
    path: "/reports/export-transaction-history",
    component: <ExportTransactionHistory />,
  },
  {
    path: "/reports/regulatory-compliance-reports",
    component: <RegulatoryComplianceReports />,
  },
  {
    path: "/platform-manager/system-configuration",
    component: <SystemConfiguration />,
  },
  {
    path: "/platform-manager/integration-management",
    component: <IntegrationManagement />,
  },
  {
    path: "/platform-manager/signers",
    component: <Signers />,
  },
  {
    path: "/icd-investments/signing-request",
    component: (
      <InvestorPermissionWrapper permission={"SIGN_ICD_SIGNING_REQUESTS"}>
        <InvestorRouteWrapper>
          <SigningRequests />
        </InvestorRouteWrapper>
      </InvestorPermissionWrapper>
    ),
  },

  //wealth partners routes
  {
    path: "/investor-management/onboard",
    component: (
      <WealthRouteWrapper>
        <ComingSoon />
      </WealthRouteWrapper>
    ),
  },
  {
    path: "/investor-management",
    component: (
      <WealthRouteWrapper>
        <InvestorManagement />
      </WealthRouteWrapper>
    ),
  },
  {
    path: "/investor-management/invite/:id",
    component: (
      <WealthRouteWrapper>
        <InvestorManagementInvite />
      </WealthRouteWrapper>
    ),
  },
  {
    path: "/investor-management/view/:id",
    component: (
      <WealthRouteWrapper>
        <InvestorManagementInviteView />
      </WealthRouteWrapper>
    ),
  },

  {
    path: "/investor-management/agreements",
    component: (
      <WealthRouteWrapper>
        <IcdMasterAgreementWp />
      </WealthRouteWrapper>
    ),
  },

  {
    path: "/investment-management/fund-requirements",
    component: (
      <WealthRouteWrapper>
        {/* <FundRequestsWp /> */}
        <ComingSoon />
      </WealthRouteWrapper>
    ),
  },
  {
    path: "/investment-management/create",
    component: (
      <WealthRouteWrapper>
        <ComingSoon />
        {/* <CreateICDInvestmentsWp /> */}
      </WealthRouteWrapper>
    ),
  },
  {
    path: "/investment-management/fund-requests",
    component: (
      <WealthRouteWrapper>
        <ComingSoon />
        {/* <ICDRequestsWp /> */}
      </WealthRouteWrapper>
    ),
  },
  {
    path: "/investment-management/fund-requests/view/:id",
    component: (
      <WealthRouteWrapper>
        <ComingSoon />
        {/* <ViewICDRequestsWp /> */}
      </WealthRouteWrapper>
    ),
  },

  {
    path: "/investment-management/payments",
    component: (
      <WealthRouteWrapper>
        <ComingSoon />
        {/* <PaymentPageWp /> */}
      </WealthRouteWrapper>
    ),
  },
  {
    path: "/reports/financial_report",
    component: (
      <WealthRouteWrapper>
        <WealthFinancialReport />,
      </WealthRouteWrapper>
    ),
  },

  //Investors routes

  {
    path: "/resources/about-prachay",
    component: (
      <InvestorPermissionWrapper permission={"RESOURCES_ABOUT_PRACHAY"}>
        <AboutPrachay />
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/resources/about-icd",
    component: (
      <InvestorPermissionWrapper permission={"RESOURCES_ABOUT_ICD"}>
        <AboutIcdInvestor />
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/resources/faq",
    component: (
      <InvestorPermissionWrapper permission={"RESOURCES_FAQ"}>
        <FaqResources />
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/resources/documents",
    component: (
      <InvestorPermissionWrapper permission={"RESOURCES_DOCUMENTS"}>
        <Documents />
      </InvestorPermissionWrapper>
    ),
  },

  {
    path: "/resources/blog/:id",
    component: <BlogView />,
  },
  {
    path: "/resources/videos",
    component: (
      <InvestorPermissionWrapper permission={"RESOURCES_VIDEOS"}>
        <Playlist />
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/icd-investments/fund-requests",
    component: (
      <InvestorPermissionWrapper permission={"VIEW_FUND_REQUIREMENTS"}>
        <InvestorRouteWrapper>
          <FundRequests />
        </InvestorRouteWrapper>
      </InvestorPermissionWrapper>
    ),
  },

  {
    path: "/icd-investments/payments",
    component: (
      <InvestorPermissionWrapper permission={"ICD_PAYMENTS"}>
        <InvestorRouteWrapper>
          <PaymentPage />
        </InvestorRouteWrapper>
      </InvestorPermissionWrapper>
    ),
  },

  {
    path: "/profile/documents/icd-agreements",
    component: (
      <InvestorPermissionWrapper permission={"PROFILE_EXECUTED_DOCS"}>
        <InvestorRouteWrapper>
          <IcdMasterAgreement />,
        </InvestorRouteWrapper>
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/kyc",
    component: <KYC />,
  },
  {
    path: "/resolve-query",
    component: <ResolveKyc />,
  },

  {
    path: "/icd-investments/create",
    component: (
      <InvestorPermissionWrapper permission={"CREATE_FUND_AVAILABILITY"}>
        <InvestorRouteWrapper>
          <CreateICDInvestments />
        </InvestorRouteWrapper>
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/icd-investments/my-icds",
    component: (
      <InvestorPermissionWrapper permission={"INVESTMENTS_LIST"}>
        <InvestorRouteWrapper>
          <MyICDRequests />
        </InvestorRouteWrapper>
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/icd-investments/my-icds/view/:id",
    component: (
      <InvestorPermissionWrapper permission={"VIEW_INVESTMENT"}>
        <InvestorRouteWrapper>
          <MyICDRequestsView />
        </InvestorRouteWrapper>
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/icd-investments/my-icd/interest/view/:id",
    component: (
      <InvestorRouteWrapper>
        <MyICDRequestsView />
      </InvestorRouteWrapper>
    ),
  },
  {
    path: "/icd-investments/my-interests",
    component: (
      <InvestorRouteWrapper>
        <MyICDInterests />
      </InvestorRouteWrapper>
    ),
  },
  {
    path: "/icd-investments/icd-request-details",
    component: (
      <InvestorRouteWrapper>
        <ICDRequestDetails />
      </InvestorRouteWrapper>
    ),
  },

  {
    path: "/resources/blogs/create",
    component: <Blogs user_type="INVESTOR" />,
  },
  {
    path: "/resources/blogs/view/:id",
    component: <BlogEdit user_type="INVESTOR" />,
  },
  {
    path: "/resources/blogs",
    component: <BlogList user_type="INVESTOR" />,
  },

  {
    path: "/resources/about-us",
    component: <AboutUs />,
  },
  {
    path: "/resources/about-icds",
    component: <AboutICD />,
  },

  {
    path: "/resources/founder-message",
    component: <FounderMessage />,
  },

  {
    path: "/resources/faqs",
    component: <FaqList user_type="INVESTOR" />,
  },
  {
    path: "/resources/faqs/create",
    component: <CreateFaq user_type="INVESTOR" />,
  },
  {
    path: "/resources/faqs/view/:id",
    component: <FaqEdit user_type="INVESTOR" />,
  },
  {
    path: "/resources/investment-videos",
    component: <VideoList user_type="INVESTOR" />,
  },
  {
    path: "/resources/investment-videos/create",
    component: <UploadVideo user_type="INVESTOR" />,
  },
  {
    path: "/resources/investment-videos/view/:id",
    component: <VideoEdit user_type="INVESTOR" />,
  },
  {
    path: "/resources/sample-documents",
    component: <DocmmentList user_type="INVESTOR" />,
  },
  {
    path: "/resources/sample-documents/create",
    component: <CreateDocument user_type="INVESTOR" />,
  },
  {
    path: "/resources/sample-documents/view/:id",
    component: <DocumentEdit user_type="INVESTOR" />,
  },

  {
    path: "/help/requests",
    component: <HelpRequests />,
  },

  {
    path: "/reports/investment-schedule",
    component: (
      <InvestorPermissionWrapper permission={"INVESTMENT_SCHEDULES"}>
        <InvestmentSchedule />
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/reports/quarterly-tds",
    component: (
      <InvestorPermissionWrapper permission={"TDS_CERTIFICATES"}>
        <QuarterlyTDSCertificates type={"tds"} />
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/reports/account-statements",
    component: (
      <InvestorPermissionWrapper permission={"ACCOUNT_STATEMENTS"}>
        <QuarterlyTDSCertificates type={"soa"} />
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/profile/kyc-details/company-information",
    component: (
      <InvestorPermissionWrapper permission={"PROFILE_KYC_DETAILS"}>
        <InvestorRouteWrapper>
          <CompanyInfo />
        </InvestorRouteWrapper>
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/profile/kyc-details/bank-details",
    component: (
      <InvestorPermissionWrapper permission={"PROFILE_KYC_DETAILS"}>
        <InvestorRouteWrapper>
          <BankDetails />
        </InvestorRouteWrapper>
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/profile/kyc-details/authorised-signatory",
    component: (
      <InvestorPermissionWrapper permission={"PROFILE_KYC_DETAILS"}>
        <InvestorRouteWrapper>
          <AuthorisedSignatoryDetails />
        </InvestorRouteWrapper>
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/profile/kyc-details/kyc-documents",
    component: (
      <InvestorPermissionWrapper permission={"PROFILE_KYC_DETAILS"}>
        <InvestorRouteWrapper>
          <KycDocuments />
        </InvestorRouteWrapper>
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/profile/kyc-details/personal-information",
    component: (
      <InvestorPermissionWrapper permission={"PROFILE_KYC_DETAILS"}>
        <InvestorRouteWrapper>
          <PersonalInformation />
        </InvestorRouteWrapper>
      </InvestorPermissionWrapper>
    ),
  },

  {
    path: "/profile/updates",
    component: (
      <InvestorPermissionWrapper permission={"PROFILE_UPDATE"}>
        <InvestorRouteWrapper>
          <InvestorsProfileUpdate />
        </InvestorRouteWrapper>
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/profile/updates/view/:id",
    component: (
      <InvestorPermissionWrapper permission={"PROFILE_UPDATE"}>
        <InvestorRouteWrapper>
          <ViewInvestorsProfileRequest />
        </InvestorRouteWrapper>
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/manage-users",
    component: (
      <InvestorPermissionWrapper permission={"USERS_LIST"}>
        <InvestorUsers />
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/manage-users/create",
    component: (
      <InvestorPermissionWrapper permission={"USERS_CREATE"}>
        <CreateInvestorUsers />
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/manage-users/edit/:id",
    component: (
      <InvestorPermissionWrapper permission={"USERS_UPDATE"}>
        <EditInvestorUsers />
      </InvestorPermissionWrapper>
    ),
  },
  {
    path: "/notifications",
    component: <Notifications />,
  },
  {
    path: "/forbidden",
    component: <Forbidden />,
  },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  {
    path: "*",
    component: <NotFound />,
  },
]

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/reset-password/:token", component: <ResetPassword /> },
  { path: "/two-factor/:token", component: <TwoFactor /> },
  { path: "/admin/login", component: <AdminLogin /> },
  { path: "/admin/forgot-password", component: <AdminForgotPassword /> },
  { path: "admin/reset-password/:token", component: <AdminResetPassword /> },
  { path: "/admin/two-factor/:token", component: <TwoFactorAdmin /> },
  { path: "/admin/verify-account/:token", component: <AdminVerify /> },
  { path: "/register", component: <Register /> },
  { path: "/verify-account/:token", component: <Verify /> },
]

export { authProtectedRoutes, publicRoutes }
